import clonedeep from 'lodash.clonedeep';

const groupIds = [
  ['whitespace_top', 'whitespace_bottom'],
  ['border', 'shadow'],
  ['filter', 'overlay'],
  ['gradient', 'show_background_image'],
  ['show_background_image', 'filter'],
  ['show_background_image', 'overlay'],
  ['expanded_items', 'multiple'],
  ['border_bottom', 'border_width'],
  ['animation', 'animation_speed'],
  ['filter_media', 'overlay'],
  ['overlay', 'overlay_opacity'],
  ['filter_media', 'fill_item'],
  ['filter_media', 'media_decoration'],
];

const isGroupInSequence = (startIndex, group, displayOptions) =>
  group.every((groupEl, groupIndex) => {
    const currentIndex = startIndex + groupIndex;
    return currentIndex < displayOptions.length && displayOptions[currentIndex].id === groupEl;
  });

const groupDisplayOptions = (displayOptions) => {
  const newDisplayOptions = clonedeep(displayOptions);

  groupIds.forEach((group) => {
    const startIndex = newDisplayOptions.findIndex((obj) => obj.id === group[0]);

    if (startIndex !== -1 && isGroupInSequence(startIndex, group, newDisplayOptions)) {
      group.slice(0, -1).forEach((groupEl, index) => {
        newDisplayOptions[startIndex + index].isGrouped = true;
      });
    }
  });

  return newDisplayOptions;
};

export default groupDisplayOptions;
